/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskTotalRevenue
 */
export interface ExecRiskTotalRevenue {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskTotalRevenue
     */
    total_revenue_column_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskTotalRevenue
     */
    related_or_exempt_func_income_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskTotalRevenue
     */
    unrelated_business_revenue_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskTotalRevenue
     */
    exclusion_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskTotalRevenue interface.
 */
export function instanceOfExecRiskTotalRevenue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskTotalRevenueFromJSON(json: any): ExecRiskTotalRevenue {
    return ExecRiskTotalRevenueFromJSONTyped(json, false);
}

export function ExecRiskTotalRevenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskTotalRevenue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_revenue_column_amt': !exists(json, 'total_revenue_column_amt') ? undefined : json['total_revenue_column_amt'],
        'related_or_exempt_func_income_amt': !exists(json, 'related_or_exempt_func_income_amt') ? undefined : json['related_or_exempt_func_income_amt'],
        'unrelated_business_revenue_amt': !exists(json, 'unrelated_business_revenue_amt') ? undefined : json['unrelated_business_revenue_amt'],
        'exclusion_amt': !exists(json, 'exclusion_amt') ? undefined : json['exclusion_amt'],
    };
}

export function ExecRiskTotalRevenueToJSON(value?: ExecRiskTotalRevenue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_revenue_column_amt': value.total_revenue_column_amt,
        'related_or_exempt_func_income_amt': value.related_or_exempt_func_income_amt,
        'unrelated_business_revenue_amt': value.unrelated_business_revenue_amt,
        'exclusion_amt': value.exclusion_amt,
    };
}

